import { _delete, _get, _patch, _save } from 'frontcore/utils/communications/apiClient'
import { GEMBA_WALK_ASSESSMENTS_ROUTE } from 'frontend/constants/gembaWalk'
import { ISOLATED_ASSESSMENTS_ROUTE } from 'frontend/constants/sfm'

export const URL_BASE_FACE_TO_FACE = 'gemba-walk-face-to-face'
export const URL_BASE_GEMBA_WALK_BY_CHECKPOINT = 'gemba-walk-by-check-point'
export const URL_BASE_GEMBA_WALK_BY_CHECKPOINT_TABLES = 'gemba-walk-by-check-point-tables'
export const URL_BASE_GEMBA_WALK_CATEGORIES = 'gemba-walk-categories'
export const URL_BASE_GEMBA_WALK_CHECK_POINTS = 'gemba-walk-check-points'
export const URL_BASE_GEMBA_WALK_MY_OWN_CHECK_POINTS = 'gemba-walk-my-own-check-points'
export const URL_BASE_GEMBA_WALK_ALL_RELATED_CHECK_POINTS = 'gemba-walk-all-related-check-points'
export const URL_BASE_GEMBA_WALK_KPIS = 'gemba-walk-kpis'
export const URL_BASE_MY_GEMBA_WALKS = 'my-gemba-walks'
export const URL_BASE_GEMBA_WALK_ROUNDS_ACTIVITIES = `${URL_BASE_MY_GEMBA_WALKS}/{0}/entries`

export function getGembaWalkCategories () {
  const url = `${URL_BASE_GEMBA_WALK_CATEGORIES}/`
  return _get(url)
}

export function getGembaWalkKpis () {
  const url = `${URL_BASE_GEMBA_WALK_KPIS}/`
  return _get(url)
}

export function getGembaWalkCheckpoints () {
  const url = `${URL_BASE_GEMBA_WALK_CHECK_POINTS}/?format=info`
  return _get(url)
}

export function getGembaWalkAllRelatedCheckpoints (perimeterId) {
  const url = `${URL_BASE_GEMBA_WALK_ALL_RELATED_CHECK_POINTS}/?perimeter=${perimeterId}`
  return _get(url)
}

export function getGembaWalkCheckpointById (id) {
  const url = `${URL_BASE_GEMBA_WALK_CHECK_POINTS}/${id}/?format=expanded`
  return _get(url)
}

export function getGembaWalkMyOwnCheckpointById (id) {
  const url = `${URL_BASE_GEMBA_WALK_MY_OWN_CHECK_POINTS}/${id}/?format=expanded`
  return _get(url)
}

export function saveGembaWalkCheckpoints (data) {
  const url = `${URL_BASE_GEMBA_WALK_CHECK_POINTS}/`
  return _save(url, data, true)
}

export function editGembaWalkCheckPoint (id, data) {
  const url = `${URL_BASE_GEMBA_WALK_CHECK_POINTS}/${id}/`
  return _patch(url, data)
}

export function deleteGembaWalkCheckPoint (id) {
  const url = `${URL_BASE_GEMBA_WALK_CHECK_POINTS}/${id}/`
  return _delete(url)
}

export function deleteGembaWalkSchedule (id) {
  const url = `${URL_BASE_MY_GEMBA_WALKS}/${id}/`
  return _delete(url)
}

export function getGembaWalkSchedule (id) {
  const url = `${URL_BASE_MY_GEMBA_WALKS}/${id}/`
  return _get(url)
}

export function getGembaWalkScheduleEntry (round, id) {
  const url = `${URL_BASE_GEMBA_WALK_ROUNDS_ACTIVITIES.replace('{0}', round)}/${id}/?format=expanded`
  return _get(url)
}

export function getGembaWalkAssessment (id) {
  const url = `${GEMBA_WALK_ASSESSMENTS_ROUTE}/${id}/?format=expanded`
  return _get(url)
}

export function getIsolatedAssessment (id) {
  const url = `${ISOLATED_ASSESSMENTS_ROUTE}/${id}/`
  return _get(url)
}

export function getGembaWalkByCheckpointCheckpoint (id) {
  const url = `${URL_BASE_GEMBA_WALK_BY_CHECKPOINT}/${id}/`
  return _get(url)
}

export function getGembaWalkByCheckpointLatestResults (id) {
  const url = `${URL_BASE_GEMBA_WALK_BY_CHECKPOINT_TABLES}/${id}/latest-results/`
  return _get(url)
}

export function getGembaWalkByCheckpointRoleLatestResults (id) {
  const url = `${URL_BASE_GEMBA_WALK_BY_CHECKPOINT_TABLES}/${id}/latest-results-reaction-rules-by-role/`
  return _get(url)
}

export function getFaceToFaceById (id) {
  const url = `${URL_BASE_FACE_TO_FACE}/${id}/`
  return _get(url)
}

export function saveFaceToFace (data) {
  const url = `${URL_BASE_FACE_TO_FACE}/`
  return _save(url, data, true)
}

export function getFaceToFacePilots () {
  const url = `${URL_BASE_FACE_TO_FACE}/creators/`
  return _get(url)
}
